import {
  IMPACT_CENTER_ARTIFACTORY_STORAGE_INFO,
  IMPACT_CENTER_CURATION_OVERVIEW,
  IMPACT_CENTER_METRICS,
  IMPACT_CENTER_XRAY_ADOPTION,
} from "@shared/services/tour/urls/impact-center-urls.ts";
import impactCenterMetrics from "@shared/services/tour/mockedApis/impactCenter/impactCenterMetrics.ts";
import impactCenterXrayAdoption from "@shared/services/tour/mockedApis/impactCenter/impactCenterXrayAdoption.ts";
import impactCenterCurationOverview from "@shared/services/tour/mockedApis/impactCenter/impactCenterCurationOverview.ts";
import impactCenterArtifactoryStorageInfo from "@shared/services/tour/mockedApis/impactCenter/impactCenterArtifactoryStorageInfo.ts";
import { TourUrlMapping } from "@shared/types/localTypes/tour.ts";

export default {
  [IMPACT_CENTER_METRICS]: () => impactCenterMetrics(),
  [IMPACT_CENTER_XRAY_ADOPTION]: () => impactCenterXrayAdoption(),
  [IMPACT_CENTER_CURATION_OVERVIEW]: () => impactCenterCurationOverview(),
  [IMPACT_CENTER_ARTIFACTORY_STORAGE_INFO]: () =>
    impactCenterArtifactoryStorageInfo(),
} satisfies TourUrlMapping;
